import OtpPage from "@/pages/auth/otp";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_login/otp")({
	component: () => <OtpPage />,
});
